import { VaporBadge, VaporBadgeProps } from "../VaporBadge";
export const StatusBadge = VaporBadge;
export interface StatusBadgeProps extends VaporBadgeProps {}
